import React from 'react'
import listmark from '../assets/images/listmark.png'
import { motion } from 'framer-motion'

// Animation variants
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
}

const HeroSection = () => {
  const listItems = [
    { text: 'Quality Product' },
    { text: 'Latest Technology Stack' },
    { text: 'Trusted by Startups to Fortune 500' },
    { text: 'Faster Time to Market with an Agile Approach' },
    { text: 'Top-tier Data Security Protocols' },
    { text: 'On-time Delivery, No Surprises' }
  ];

  const stats = [
    { number: 10, label: 'Year in Business' },
    { number: 500, label: 'Apps Delivered' },
    { number: 250, label: 'Mobile App Developers' },
    { number: 250, label: 'Clients Worldwide' }
  ];

  return (
    <motion.div
      className='flex flex-col lg:flex-row justify-between items-center'
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={containerVariants}
    >
      {/* Left Section */}
      <motion.div
        className='text-secondaryColor w-full lg:w-1/2'
        variants={itemVariants}
      >
        <motion.h1
          className='text-7xl font-semibold sm:text-8xl mb-5 sm:font-bold'
          variants={itemVariants}
        >
          From Idea to{' '}
          <span className='text-transparent bg-clip-text bg-gradient-to-tr from-[#ED8B29] to-[#FFD23F]'>
            delivery
          </span>
        </motion.h1>

        <motion.h1
          className='text-xl sm:text-2xl lg:text-4xl'
          variants={itemVariants}
        >
          Unlock the full potential of your project with our company
        </motion.h1>

        <motion.ul
          className='sm:py-5 lg:py-10'
          variants={containerVariants}
        >
          {listItems.map((item, index) => (
            <motion.li
              key={index}
              className='flex gap-x-2 my-3 items-start'
              variants={itemVariants}
            >
              {/* <svg
                className='w-4 mt-1 sm:w-7'
                fill="#232b50"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-42.41 -42.41 508.93 508.93"
                xmlSpace="preserve"
              >
                <g>
                  <g>
                    <path d="M376.955,120.307..."></path>
                    <path d="M420.654,14.931..."></path>
                  </g>
                </g>
              </svg> */}
              {/* <img src={listmark} alt="" /> */}
              <p className='sm:text-lg font-semibold text-secondaryColor'>{item.text}</p>
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>

      {/* Right Section (Stats) */}
      <motion.div
        className='grid grid-cols-2 gap-4 sm:mb-5 relative'
        variants={containerVariants}
      >
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            className='rounded-full shadow-lg flex flex-col justify-center w-36 h-36 sm:w-60 text-center items-center sm:h-60'
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
          >
            <h1 className='text-transparent bg-clip-text bg-gradient-to-tr from-[#ED8B29] to-[#FFD23F] font-extrabold text-3xl sm:text-6xl'>
              {stat.number}
            </h1>
            <p className='text-secondaryColor font-semibold text-sm sm:text-xl sm:text-nowrap'>
              {stat.label}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  )
}

export default HeroSection
